
export const loomSdkStates = {
  sdkNotLoaded: "Initializing",
  noLoomTokenGenerated: "Loom is currently unavailable",
  recordingNotSupported: "Recording not supported",
  loading: "Loading...",
  loaded: "Loaded",
}

export const loomRecordButtonStates = {
  record: 'Record',
  recording: 'Recording...',
  uploading: 'Uploading...',
}